import { render, staticRenderFns } from "./Lgx243090039976755200.vue?vue&type=template&id=8df775e2&scoped=true&"
import script from "./Lgx243090039976755200.vue?vue&type=script&lang=js&"
export * from "./Lgx243090039976755200.vue?vue&type=script&lang=js&"
import style0 from "./Lgx243090039976755200.vue?vue&type=style&index=0&id=8df775e2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8df775e2",
  null
  
)

export default component.exports